export default {
	game_id: "ice_bar_27",
	gameName: "Ice Bar 27",

	stageWidth: 1280,
	stageHeight: 720,

	scripts: [
		"framework/src/vendor/jquery.min.js",
		"framework/src/vendor/tween.js",
		"framework/src/vendor/ph.js",
	],

	game: {
		audio: {
			tracks: [],
		},
		freespins: {
			autostart: true,
		},
		webfonts: ["UbuntuMono-Regular", "Audiowide-Regular"],
	},
	system: {
		audio: {
			tracks: [
				{
    name: 'Jackpot_sound',
    classVol: 'volume.normalWin',
    loop: false,
},
{
    name: 'JokerBonus_alert',
    classVol: 'volume.normalWin',
    loop: false,
},

			],
		},
	},
};
